import { utils, writeFile } from 'xlsx'
import { useCallback } from 'react'

export const useSpreadsheet = () => {
  const exportFile = useCallback((data, fileName) => {
    /* convert state to workbook */
    const ws = utils.aoa_to_sheet(data)
    const wb = utils.book_new()
    utils.book_append_sheet(wb, ws, fileName)
    /* generate XLSX file and send to client */
    writeFile(wb, `${fileName}.xlsx`)
  }, [])

  return {
    exportFile,
  }
}
